<div *ngIf="isLoading | async" class="overlay">
	<div class="spinner"></div>
	<div class="text" *ngIf="displayLoadingText">
		{{ displayLoadingText }}
	</div>
</div>
